import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-los-discount-table-overlay',
  templateUrl: './los-discount-table-overlay.component.html',
  styleUrls: ['./los-discount-table-overlay.component.scss'],
})
export class LosDiscountTableOverlayComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { channelId: string; rentalId: string },
    public dialogRef: MatDialogRef<LosDiscountTableOverlayComponent>
  ) {}

  close() {
    this.dialogRef.close()
  }
}
